import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
import moment from "moment";
import UploadAndDownloadService from "../uploadAndDownloadFile";

const addLeaveRequest = async (leaveRequestModel, file) => {
  try {
    const leaveRequestMode = {
      ...leaveRequestModel,
      dateDeb: moment(leaveRequestModel.dateDeb).format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      ),
      dateFin: moment(leaveRequestModel.dateFin).format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      ),
    };

    let fileUrl = "";
    if (file && file.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", file);

      // Await the upload operation
      const response = await UploadAndDownloadService.uploadFile(
        "/rh/uploadFileRH/uploadFile/LeaveRequest",
        uploadData
      );

      fileUrl = response.data.success;
    }

    leaveRequestMode.fileUrl = fileUrl;

    const response = await api.post(
      UtilsUrl.rhURL() + `/leaveRequest/addLeaveRequest`,
      leaveRequestMode
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Response Data:", error.response.data);
      console.error("Response Status:", error.response.status);
      console.error("Response Headers:", error.response.headers);
    } else {
      console.error("Error while making the request:", error.message);
    }
    throw error;
  }
};

const getLeaveRequestsByEmployeeId = async (idEmp) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() +
        `/leaveRequest/getAllLeaveRequestsByIdEmployee/${idEmp}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const AddLeaveRequestByAdmin = async (LRModel, file) => {
  try {
    console.log(JSON.stringify(LRModel));
    let fileUrl = "";
    if (file && file.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", file);

      // Await the upload operation
      const response = await UploadAndDownloadService.uploadFile(
        "/rh/uploadFileRH/uploadFile/LeaveRequest",
        uploadData
      );

      fileUrl = response.data.success;
    } else {
      fileUrl = "";
    }

    LRModel.fileUrl = fileUrl;
    console.log(JSON.stringify(LRModel));
    const responseLR = await api.post(
      UtilsUrl.rhURL() + `/leaveRequest/adminAddLeaveRequest`,
      LRModel
    );
    return responseLR;
  } catch (error) {
    throw error.response.data;
  }
};
const getVacationDays = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/leaveRequest/vacation/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const getLeaveRequests = (idUser) => {
  try {
    const response = api.get(UtilsUrl.rhURL() + `/leaveRequest/` + idUser);
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const getLeaveRequestsStatus = (idUser) => {
  try {
    const response = api.get(
      UtilsUrl.rhURL() + `/leaveRequest/getLeaveRequestsStatus/` + idUser
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const approveLeaveRequest = (id, userId) => {
  const response = api.put(
    UtilsUrl.rhURL() +
      `/leaveRequest/approveLeaveRequest/${id}?userId=${userId}`
  );

  return response;
};
const rejectLeaveRequest = (id, userId) => {
  const response = api.put(
    UtilsUrl.rhURL() + `/leaveRequest/rejectLeaveRequest/${id}?userId=${userId}`
  );

  return response;
};
const updateLeaveRequest = async (file, leaveRequestModel, fileUrlSelected) => {
  try {
    const leaveRequestMode = {
      remarque: leaveRequestModel.remarque,
      idLeaveRequest: leaveRequestModel.idLeaveRequest,
      idEmployee: leaveRequestModel.idEmployee,
      idLeaveType: leaveRequestModel.idLeaveType,
      dateDeb: moment(leaveRequestModel.dateDeb).format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      ),
      dateFin: moment(leaveRequestModel.dateFin).format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      ),
    };
    let fileUrl = "";
    if (file && file.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", file);

      // Await the upload operation
      const response = await UploadAndDownloadService.uploadFile(
        "/rh/uploadFileRH/uploadFile/LeaveRequest",
        uploadData
      );

      // Check if response is not undefined
      fileUrl = response.data.success;
    } else {
      fileUrl = fileUrlSelected;
    }
    leaveRequestMode.fileUrl = fileUrl;
    const response = await api.put(
      // Await the API call
      UtilsUrl.rhURL() + "/leaveRequest/updateLeaveRequest",
      leaveRequestMode
    );

    return response;
  } catch (error) {
    throw error;
  }
};

const getLeaveStats = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/leaveRequest/getLeaveStats/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export {
  addLeaveRequest,
  getLeaveRequestsByEmployeeId,
  getVacationDays,
  getLeaveRequests,
  getLeaveRequestsStatus,
  approveLeaveRequest,
  rejectLeaveRequest,
  updateLeaveRequest,
  getLeaveStats,
  AddLeaveRequestByAdmin,
};
